package com.r_estrategica.redacaoestrategica.ui

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.*
import androidx.compose.material3.*
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp

@Composable
fun LearningPathScreen(
    isPremium: Boolean,
    aoVoltar: () -> Unit
) {
    // TESTE DO TERRENO BALDIO - LIMPANDO TUDO PARA ISOLAR O CRASH
    Box(
        modifier = Modifier
            .fillMaxSize()
            .background(Color(0xFF0B0D17)),
        contentAlignment = Alignment.Center
    ) {
        Column(horizontalAlignment = Alignment.CenterHorizontally) {
            Text(
                text = "Teste de Renderização: Trilha",
                color = Color.White,
                fontSize = 20.sp,
                fontWeight = FontWeight.Bold
            )
            
            Spacer(Modifier.height(20.dp))
            
            Button(onClick = aoVoltar) {
                Text("Voltar")
            }
        }
    }
}

/*
CÓDIGO ORIGINAL COMENTADO PARA REFERÊNCIA E ANÁLISE DE SUSPEITOS:

@Composable
fun LearningPathScreen_Original(...) {
    // ... lógica de busca Firestore ...
    
    // SUSPEITO 1: StarryUniverseBackground (Uso intensivo de Canvas e drawCircle em loop)
    // StarryUniverseBackground() 

    // SUSPEITO 2: Brush.verticalGradient com valores muito altos (1500f)
    // Box(modifier = Modifier.background(Brush.verticalGradient(...)))

    // SUSPEITO 3: Modificador .shadow(8.dp, ...) em botões
    // Button(modifier = Modifier.shadow(8.dp, ...))

    // SUSPEITO 4: LazyColumn com muitos itens dinâmicos vindos do Firestore (asDynamic)
    // LazyColumn { items(licoes) { ... } }

    // SUSPEITO 5: Mapeamento de 'asDynamic' dentro do LaunchedEffect
    // Se o objeto JS retornado pelo Firestore tiver uma estrutura que o Kotlin/JS 
    // não consegue converter durante a recomposição, pode corromper o estado.
}
*/
